import { render, staticRenderFns } from "./TOPersonalStats.vue?vue&type=template&id=5fd5b755&scoped=true&"
import script from "./TOPersonalStats.vue?vue&type=script&lang=js&"
export * from "./TOPersonalStats.vue?vue&type=script&lang=js&"
import style0 from "./TOPersonalStats.vue?vue&type=style&index=0&id=5fd5b755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd5b755",
  null
  
)

export default component.exports